(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["board-of-directors"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const openModal = (button) => {
      const modal = document.getElementById(button.dataset.modal);
      if (!modal) return;
      modal.hidden = false;
      button.setAttribute('aria-expanded', 'true');
      modal.querySelector('.board-modal-close')?.focus();
    };

    const closeModal = (modal) => {
      if (!modal) return;
      modal.hidden = true;
      const opener = document.querySelector(`[data-modal="${modal.id}"]`);
      opener?.setAttribute('aria-expanded', 'false');
      opener?.focus();
    };

    document.addEventListener('click', (event) => {
      const opener = event.target.closest('.board-plus');
      if (opener) return openModal(opener);

      const closer = event.target.closest('.board-modal-close');
      if (closer) return closeModal(document.getElementById(closer.dataset.close));

      if (event.target.classList.contains('board-modal')) closeModal(event.target);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeModal(document.querySelector('.board-modal:not([hidden])'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["management"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const openModal = (button) => {
      const modal = document.getElementById(button.dataset.modal);
      if (!modal) return;
      modal.hidden = false;
      button.setAttribute('aria-expanded', 'true');
      modal.querySelector('.board-modal-close')?.focus();
    };

    const closeModal = (modal) => {
      if (!modal) return;
      modal.hidden = true;
      const opener = document.querySelector(`[data-modal="${modal.id}"]`);
      opener?.setAttribute('aria-expanded', 'false');
      opener?.focus();
    };

    document.addEventListener('click', (event) => {
      const opener = event.target.closest('.board-plus');
      if (opener) return openModal(opener);

      const closer = event.target.closest('.board-modal-close');
      if (closer) return closeModal(document.getElementById(closer.dataset.close));

      if (event.target.classList.contains('board-modal')) closeModal(event.target);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeModal(document.querySelector('.board-modal:not([hidden])'));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
